import styled, { css } from 'styled-components';
import { ColorAddiCompFiveBase, ColorAddiCompFiveLighten4, ColorAddiCompTwoBase, ColorAddiCompTwoLighten4, ColorAddiCompThreeBase, ColorAddiCompThreeLighten4, ColorAddiCompFourLighten2, ColorAddiCompFourLighten4, ColorAddiFontPrimary, ColorAddiFontSuccess, ColorAddiFontError } from '@addi/foundation/dist/web/colors';
import { FontAddiFamilyPrimaryName, FontAddiWeightMedium, FontAddiWeightSemiBold, } from '@addi/foundation/dist/web/fonts';
import { SizeAddiFontXSmall } from '@addi/foundation/dist/web/sizes';
import { Icon } from '../../styled-icon';
const alertBaseCss = css `
    display: flex;
    flex-direction: row;
    align-items: flex-start;

    padding: 10px;
    font-size: ${SizeAddiFontXSmall};
    font-family: ${FontAddiFamilyPrimaryName};
    font-weight: ${FontAddiWeightMedium};
    border: 2px solid;
    border-radius: 5px;
`;
export const PrimaryWarningAlert = styled.div `
    ${alertBaseCss}
    border-color: ${ColorAddiCompTwoBase};
    color: ${ColorAddiFontPrimary};

    ${Icon} {
        margin-right: 10px;
        color: ${ColorAddiCompTwoBase};
    }
`;
export const SecondaryWarningAlert = styled(PrimaryWarningAlert) `
    background: ${ColorAddiCompTwoLighten4};
    font-weight: ${FontAddiWeightSemiBold};
`;
export const PrimaryErrorAlert = styled.div `
    ${alertBaseCss}
    border-color: ${ColorAddiCompFourLighten2};
    color: ${ColorAddiFontError};

    ${Icon} {
        margin-right: 10px;
        color: ${ColorAddiCompFourLighten2};
    }
`;
export const SecondaryErrorAlert = styled(PrimaryErrorAlert) `
    background: ${ColorAddiCompFourLighten4};
    font-weight: ${FontAddiWeightSemiBold};
`;
export const PrimaryInfoAlert = styled.div `
    ${alertBaseCss}
    border-color: ${ColorAddiCompFiveBase};
    color: ${ColorAddiFontPrimary};

    ${Icon} {
        margin-right: 10px;
        color: ${ColorAddiCompFiveBase};
    }
`;
export const SecondaryInfoAlert = styled(PrimaryInfoAlert) `
    background: ${ColorAddiCompFiveLighten4};
    font-weight: ${FontAddiWeightSemiBold};
`;
export const PrimarySuccessAlert = styled.div `
    ${alertBaseCss}
    border-color: ${ColorAddiCompThreeBase};
    color: ${ColorAddiFontSuccess};

    ${Icon} {
        margin-right: 10px;
        color: ${ColorAddiCompThreeBase};
    }
`;
export const SecondarySuccessAlert = styled(PrimarySuccessAlert) `
    background: ${ColorAddiCompThreeLighten4};
    font-weight: ${FontAddiWeightSemiBold};
`;
//# sourceMappingURL=Alerts.styled.js.map